import { render } from "./StopColorsInfoPopup.vue?vue&type=template&id=09c07608&scoped=true"
import script from "./StopColorsInfoPopup.vue?vue&type=script&lang=js"
export * from "./StopColorsInfoPopup.vue?vue&type=script&lang=js"

import "./StopColorsInfoPopup.vue?vue&type=style&index=0&id=09c07608&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c07608"]])

export default __exports__